export default __webpack_public_path__ + "static/media/ImageUploadIcon.958efb3a.svg";